import {
  PRIVILEGE_FETCH_SUCCESS,
  PRIVILEGES_FETCH_SUCCESS,
} from "../actions/types";

const INIT_STATE = {
  privilege: {},
  privileges: [],
};

export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case PRIVILEGE_FETCH_SUCCESS: {
      return {
        ...state,
        privilege: action.payload,
      };
    }
    case PRIVILEGES_FETCH_SUCCESS: {
      return {
        ...state,
        privileges: action.payload,
      };
    }
    default:
      return state;
  }
};
